import i18n from 'modules/core/lib/i18n'

import { LOCATION_TYPES } from 'modules/attendance/store/models/Shift'

export const locationTypeText = (location_type: string) => {
  switch (location_type) {
    case LOCATION_TYPES.WORK_FROM_HOME:
      return i18n.t('clock_in.locations.select_options.work_from_home')
    case LOCATION_TYPES.OFFICE:
      return i18n.t('clock_in.locations.select_options.office')
    case LOCATION_TYPES.BUSINESS_TRIP:
      return i18n.t('clock_in.locations.select_options.business_trip')
    default:
      return ''
  }
}

export const locationTypeOptions = () => [
  {
    label: locationTypeText(LOCATION_TYPES.OFFICE!),
    value: LOCATION_TYPES.OFFICE,
  },
  {
    label: locationTypeText(LOCATION_TYPES.WORK_FROM_HOME!),
    value: LOCATION_TYPES.WORK_FROM_HOME,
  },
  {
    label: locationTypeText(LOCATION_TYPES.BUSINESS_TRIP!),
    value: LOCATION_TYPES.BUSINESS_TRIP,
  },
]
